/**
 * Un-prefixed API client for use with naptime resources.
 */
import API from 'js/lib/api';

const api = API('/api/', {
  type: 'rest',
});

export default api;
